import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useThemeStore = create(
  persist(
    (set, get) => ({
      theme: 'system',
      refreshInterval: 30,
      
      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme);
      },
      
      setRefreshInterval: (interval) => {
        set({ refreshInterval: interval });
      },
      
      initTheme: () => {
        applyTheme(get().theme);
      }
    }),
    {
      name: 'oneview-settings',
    }
  )
);

function applyTheme(theme) {
  const root = window.document.documentElement;
  root.classList.remove('light', 'dark');

  if (theme === 'system') {
    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    root.classList.add(systemTheme);
  } else {
    root.classList.add(theme);
  }
}

// Listen for system theme changes
if (typeof window !== 'undefined') {
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
    const store = useThemeStore.getState();
    if (store.theme === 'system') {
      applyTheme('system');
    }
  });
}
